module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av283-93d257584717a0bc91536fe188af089d.jpg";